import React, {PropsWithChildren, ReactNode} from 'react';
import {Box} from '@amzn/awsui-components-react';

type LabelledValueProps = PropsWithChildren<{
    label: string,
    id: string,
}>

const LabelledValue: React.FC<LabelledValueProps> = ({ label, id, children }) =>  {
    return <div id={id} >
        <Box variant="awsui-key-label">{label}</Box>
        <div>{children}</div>
    </div>
}

export default LabelledValue;
